import { styled, Checkbox, Typography } from "@mui/material";
import { StyledAvatar } from "components/Shared/Dashboard/styled";
import UploadImageComponent from "components/Input/UploadImageComponent";
import { useFormikContext } from "formik";
import { invoiceInitialValues } from "store/reducers/factorReducer";
import uploadSignImg from "assets/images/uploadSign.svg";

const SignContainer = styled("div")(({ theme }) => ({
  padding: "16px 12px 12px 12px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  // justifyContent: 'space-between'
}));

const AvatarContainer = styled("div")(({ theme }) => ({
  width: "45px",
  height: "45px",
}));

const CustomerSignCheckboxContainer = styled("div")(({ theme }) => ({
  display: "grid",
  width: "100%",
  gridTemplateColumns: "15% 83%",
  justifyContent: "space-between",
  marginTop: "24px",
}));
const TextcontainerContainer = styled("div")(({ theme }) => ({
  grid: "flex",
  width: "100%",
  flexDirection: "column",
  // height: '50px',
  justifyContent: "space-between",
  // marginTop: '30px',
}));

const LogoPalceholder = () => {
  return (
    <AvatarContainer>
      <StyledAvatar sx={{ borderRadius: 0 }} src={uploadSignImg} />
    </AvatarContainer>
  );
};

const SignChild = () => {
  const formikContext = useFormikContext();
  const { values } = formikContext;
  const { showCustomerSign, showSellerSign } = values as typeof invoiceInitialValues;
  return (
    <SignContainer>
      <CustomerSignCheckboxContainer>
        <Checkbox
          style={{ height: 20, marginBottom: 30 }}
          checked={showSellerSign}
          onChange={() => formikContext.setFieldValue("showSellerSign", !showSellerSign)}
        />
        <TextcontainerContainer>
          <Typography variant="body2">نمایش امضا</Typography>
        </TextcontainerContainer>
      </CustomerSignCheckboxContainer>
      {showSellerSign ? (
        <>
          <UploadImageComponent
            title="آپلود تصویر امضاء"
            name="sign"
            width={296}
            height={100}
            innerWidth={280}
            innerHeight={84}
            horizontal={true}
            LogoPlaceholder={LogoPalceholder}
          />
          <CustomerSignCheckboxContainer>
            <Checkbox
              style={{ height: 40 }}
              onChange={() => formikContext.setFieldValue("showCustomerSign", !showCustomerSign)}
            />
            <TextcontainerContainer>
              <Typography variant="body2">امضا دوم</Typography>
              <Typography variant="caption">
                با فعال کردن این گزینه محل امضا دوم جهت امضا خریدار یا فروشنده در فاکتور نمایش داده می شود
              </Typography>
            </TextcontainerContainer>
          </CustomerSignCheckboxContainer>
        </>
      ) : (
        <></>
      )}
    </SignContainer>
  );
};

export default SignChild;
